import React from 'react';

type Local = 'en' | 'fr';

interface ClientHubAccessProps {
  isMobile: boolean;
  scrollTo: any;
  activeSection: string;
  track: any;
  sitelinkId: string;
  local: Local;
}

const translations: Record<Local, any> = {
  en: {
    title: 'Unit access & access code',
    intro: 'You must use your personal access code for both entry and exit.',
    findCodeHeader: 'How to find your access code',
    findCodeSteps: (sitelinkId: string, track: (eventName: string) => void) => (
      <>
        <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
          <li>
            Log in to{' '}
            <a
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noreferrer"
              onClick={() => track('Open MyAccount')}
              href={`https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=${sitelinkId}==&1=1`}
            >
              My Account
            </a>
          </li>
          <li>Select your unit</li>
          <li>
            The access code will appear below your contact information on the
            “Account Balance” page
          </li>
          <li>Or call us for assistance</li>
        </ul>
      </>
    ),
    accessUnitHeader: 'Accessing your unit',
    accessUnitBody: (scrollTo: (sectionId: string) => void) => (
      <>
        <div>
          Gate hours can be found in the{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              scrollTo('contact');
              return false;
            }}
            style={{ textDecoration: 'none' }}
          >
            Contact
          </a>{' '}
          section.
        </div>
        <br />
        <div>
          At the keypad, enter: <b>*code#</b>
        </div>
        <div>
          For example, if your access code is 12345, you would enter:{' '}
          <b>*12345#</b>
        </div>
      </>
    ),
  },
  fr: {
    title: 'Accès à votre unité et code d’accès',
    intro:
      'Vous devez obligatoirement utiliser votre code d’accès personnel pour entrer et sortir de l’installation.',
    findCodeHeader: 'Comment trouver votre code d’accès',
    findCodeSteps: (sitelinkId: string, track: (eventName: string) => void) => (
      <>
        <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
          <li>
            Ouvrez une session dans{' '}
            <a
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noreferrer"
              onClick={() => track('Open MonCompte')}
              href={`https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=${sitelinkId}==&1=1`}
            >
              Mon compte
            </a>
          </li>
          <li>Sélectionnez votre unité</li>
          <li>
            Votre code d’accès s’affichera sous vos coordonnées sur la page «
            Solde du compte »
          </li>
          <li>Ou appelez-nous pour obtenir de l’aide</li>
        </ul>
      </>
    ),
    accessUnitHeader: 'Accéder à votre unité',
    accessUnitBody: (scrollTo: (sectionId: string) => void) => (
      <>
        <div>
          Les heures d’accès sont indiquées dans la section{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              scrollTo('contact');
              return false;
            }}
            style={{ textDecoration: 'none' }}
          >
            Contact
          </a>
          .
        </div>
        <br />
        <div>
          Sur le clavier, saisissez : <b>*code#</b>
        </div>
        <div>
          Par exemple, si votre code est 12345, entrez : <b>*12345#</b>
        </div>
      </>
    ),
  },
};

const ClientHubAccess: React.FC<ClientHubAccessProps> = ({
  isMobile,
  scrollTo,
  activeSection,
  track,
  sitelinkId,
  local,
}) => {
  const id = 'access';
  const showSection = () => (isMobile ? activeSection === id : true);
  const t = translations[local];

  return (
    <div style={{ display: showSection() ? 'block' : 'none' }}>
      <h3
        id="access"
        style={{ textTransform: 'none', backgroundColor: 'aliceblue' }}
      >
        {t.title}
      </h3>
      <div>{t.intro}</div>
      <br />

      <div>
        <div>
          <b>{t.findCodeHeader}</b>
          <br />
          {t.findCodeSteps(sitelinkId, track)}
        </div>

        <hr />

        <div>
          <b>{t.accessUnitHeader}</b>
          <br />
          {t.accessUnitBody(scrollTo)}
        </div>
      </div>

      <hr />
      <br />
    </div>
  );
};

export default ClientHubAccess;
